__turbopack_context__.v({
  "root": "styles-module__qUiWhG__root",
  "wrap": "styles-module__qUiWhG__wrap",
});
